import {
  SUB_GET_ARTICLES_REQUEST,
  SUB_GET_ARTICLES_SUCCESS,
  SUB_GET_ARTICLES_FAIL,
  SUB_CREATE_ARTICLE_REQUEST,
  SUB_CREATE_ARTICLE_SUCCESS,
  SUB_CREATE_ARTICLE_FAIL,
  SUB_SAT_ARTICLE_REQUEST,
  SUB_SAT_ARTICLE_SUCCESS,
  SUB_SAT_ARTICLE_FAIL,
  SUB_PUSH_ARTICLE_REQUEST,
  SUB_PUSH_ARTICLE_SUCCESS,
  SUB_PUSH_ARTICLE_FAIL,
  SUB_REMOVE_ARTICLE_REQUEST,
  SUB_REMOVE_ARTICLE_SUCCESS,
  SUB_REMOVE_ARTICLE_FAIL
} from "../actions/sub";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {},
  editArticleRequest: false,
  successBackMsg: "",
  beginTime: "",
  sub_data: {}
};

const sub = (state = initialState, action) => {
  switch (action.type) {
    case SUB_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case SUB_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        articles: action.data.data,
        articlesPagination: {
          currentPage: action.data.current_page,
          lastPage: action.data.last_page
        }
      };
    case SUB_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors
      };
    case SUB_CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case SUB_CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case SUB_CREATE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };
    case SUB_SAT_ARTICLE_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case SUB_SAT_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: "",
        successMsg: "",
        errors: {},
        sub_data: action.data
      };
    case SUB_SAT_ARTICLE_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: "",
        successMsg: "",
        errors: action.errors
      };
    case SUB_PUSH_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case SUB_PUSH_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case SUB_PUSH_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };
    case SUB_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {},
        selectedArticle: {}
      };
    case SUB_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedArticle: {}
      };
    case SUB_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedArticle: {}
      };

    default:
      return state;
  }
};

export default sub;
